import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Link from 'next/link'
import Modal from 'react-responsive-modal'
import ReactSVG from 'react-svg'
import { useRouter } from 'next/router'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { getFilteredFields, getLoading } from 'SRC/modules/vehicleParts/filter/selectors'
import { setShowFilterModal } from 'SRC/modules/vehicleParts/list/actions'
import { fetchFilteredFields } from 'SRC/modules/vehicleParts/filter/actions'
import { getPagination, getShowFilterModal } from 'SRC/modules/vehicleParts/list/selectors'
import { AdFilterShowDetailBtn, SelectDropdown, AdFilterField } from 'SRC/ui/FormElementsNew'
import { Field } from 'SRC/modules/vehicleParts/filter/Field'
import { getUrl } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'
import useTranslation from 'next-translate/useTranslation'
import { TextSearch } from 'SRC/modules/vehicleParts/filter/components/TextSearch'
import { TextSearchMobile } from 'SRC/modules/vehicleParts/filter/components/TextSearchMobile'
import { FilterTabs } from 'SRC/modules/vehicleParts/filter/components/FilterTabs'
import { VehiclePartsSummaryBar } from 'SRC/modules/vehicleParts/filter/components/VehiclePartsSummaryBar'
import { Buttons } from '../Buttons'
import { ButtonMobile } from '../ButtonMobile'

import translations from '../../../../../../../public/data/translations.json'

const Width = ({
  filteredFields,
  width,
  setWidth,
  isDisabled,
}) => {
  const { t } = useTranslation('common')

  const getWidthOptions = () => {
    if (!Array.isArray(filteredFields?.data?.width) || !filteredFields?.data?.width.length || isDisabled) return []

    return filteredFields.data.width.map((item) => ({
      id: `width-${item.slug}`,
      value: item.slug,
      label: item.name
    }))
  }

  const getIsWidthDisabled = () => {
    if (!Array.isArray(filteredFields?.data?.width) || !filteredFields?.data?.width.length || isDisabled) return true

    return false
  }

  const onWidthChange = (width) => {
    if (isDisabled) return

    setWidth(width)
  }

  return (
    <Field
      key='width'
      id='width'
      name='width'
      value={width}
      title={t('Širina')}
      options={getWidthOptions()}
      isDisabled={getIsWidthDisabled()}
      onValueChanged={onWidthChange}
      className='polja-pretrage-item__gume polja-pretrage-item__dimenzije'
    />
  )
}

const Height = ({
  filteredFields,
  height,
  setHeight,
  isDisabled
}) => {
  const { t } = useTranslation('common')

  const getHeightOptions = () => {
    if (!Array.isArray(filteredFields?.data?.height) || !filteredFields?.data?.height.length || isDisabled) return []

    return filteredFields.data.height.map((item) => ({
      id: `height-${item.slug}`,
      value: item.slug,
      label: item.name
    }))
  }

  const getIsHeightDisabled = () => {
    if (!Array.isArray(filteredFields?.data?.height) || !filteredFields?.data?.height.length || isDisabled) return true

    return false
  }

  const onHeightChange = (height) => {
    if (isDisabled) return

    setHeight(height)
  }

  return (
    <Field
      key='height'
      id='height'
      name='height'
      value={height}
      title={t('Visina')}
      options={getHeightOptions()}
      isDisabled={getIsHeightDisabled()}
      onValueChanged={onHeightChange}
      className='polja-pretrage-item__gume polja-pretrage-item__dimenzije'
    />
  )
}

const Diameter = ({
  filteredFields,
  diameter,
  setDiameter,
  isDisabled
}) => {
  const { t, lang } = useTranslation('common')

  const getDiameterOptions = () => {
    if (!Array.isArray(filteredFields?.data?.diameter) || !filteredFields?.data?.diameter.length || isDisabled) return []

    return filteredFields.data.diameter.map((item) => ({
      id: `diameter-${item.slug}`,
      value: item.slug,
      label: item.name
    }))
  }

  const getIsDiameterDisabled = () => {
    if (!Array.isArray(filteredFields?.data?.diameter) || !filteredFields?.data?.diameter.length || isDisabled) return true

    return false
  }

  const onDiameterChange = (diameter) => {
    if (isDisabled) return

    setDiameter(diameter)
  }

  return (
    <Field
      key='diameter'
      id='diameter'
      name='diameter'
      value={diameter}
      title={t('Promjer')}
      options={getDiameterOptions()}
      isDisabled={getIsDiameterDisabled()}
      onValueChanged={onDiameterChange}
      className='polja-pretrage-item__gume polja-pretrage-item__dimenzije'
    />
  )
}

const Season = ({
  filteredFields,
  season,
  setSeason,
  isDisabled
}) => {
  const { t } = useTranslation('common')

  const getSeasonOptions = () => {
    if (!Array.isArray(filteredFields?.data?.season) || !filteredFields?.data?.season.length || isDisabled) return []

    return filteredFields.data.season.map((item) => ({
      id: `season-${item.slug}`,
      value: item.slug,
      label: item.name
    }))
  }

  const getIsSeasonDisabled = () => {
    if (!Array.isArray(filteredFields?.data?.season) || !filteredFields?.data?.season.length || isDisabled) return true

    return false
  }

  const onSeasonChange = (season) => {
    if (isDisabled) return

    setSeason(season)
  }

  return (
    <Field
      key='season'
      id='season'
      name='season'
      value={season}
      title={t('Sezona')}
      options={getSeasonOptions()}
      isDisabled={getIsSeasonDisabled()}
      onValueChanged={onSeasonChange}
      className='polja-pretrage-item__gume polja-pretrage-item__sezona'
    />
  )
}

const VehicleType = ({
  filteredFields,
  tipVozila,
  setTipVozila,
  isDisabled
}) => {
  const { t } = useTranslation('common')

  const getVehicleTypeOptions = () => {
    if (!Array.isArray(filteredFields?.data?.tire_vehicle_type) || !filteredFields?.data?.tire_vehicle_type.length || isDisabled) return []

    return filteredFields.data.tire_vehicle_type.map((item) => ({
      id: `tire_vehicle_type-${item.slug}`,
      value: item.slug,
      label: item.name
    }))
  }

  const getIsVehicleTypeDisabled = () => {
    if (!Array.isArray(filteredFields?.data?.tire_vehicle_type) || !filteredFields?.data?.tire_vehicle_type.length || isDisabled) return true

    return false
  }

  const onVehicleTypeChange = (vehicleType) => {
    if (isDisabled) return

    setTipVozila(vehicleType)
  }

  return (
    <Field
      key='tire_vehicle_type'
      id='tire_vehicle_type'
      name='tire_vehicle_type'
      value={tipVozila}
      title={t('Tip vozila')}
      options={getVehicleTypeOptions()}
      isDisabled={getIsVehicleTypeDisabled()}
      onValueChanged={onVehicleTypeChange}
      className='polja-pretrage-item__gume'
    />
  )
}

const Brand = ({
  filteredFields,
  manufacturer,
  setManufacturer,
  isDisabled
}) => {
  const { t } = useTranslation('common')

  const getBrandOptions = () => {
    if (!Array.isArray(filteredFields?.data?.manufacturer) || !filteredFields?.data?.manufacturer.length || isDisabled) return []

    return filteredFields.data.manufacturer.map((item) => ({
      id: `manufacturer-${item.slug}`,
      value: item.slug,
      label: item.name
    }))
  }

  const getIsBrandDisabled = () => {
    if (!Array.isArray(filteredFields?.data?.manufacturer) || !filteredFields?.data?.manufacturer.length || isDisabled) return true

    return false
  }

  const onBrandChange = (brand) => {
    if (isDisabled) return

    setManufacturer(brand)
  }

  return (
    <Field
      key='manufacturer'
      id='manufacturer'
      name='manufacturer'
      value={manufacturer}
      title={t('Proizvođač')}
      options={getBrandOptions()}
      isDisabled={getIsBrandDisabled()}
      onValueChanged={onBrandChange}
      className='polja-pretrage-item__gume polja-pretrage-item__proizvodjac'
    />
  )
}

const CountText = ({ count }) => {
  const { t } = useTranslation('common')

  if (!count) return <span />
  if (count === 1) {
    return <span style={{ marginLeft: '0.5rem', fontSize: '1rem' }}><strong>1</strong> {t('proizvod pronađen')}</span>
  }

  if (count === 2) {
    return <span style={{ marginLeft: '0.5rem', fontSize: '1rem' }}><strong>2</strong> {t('pronađena proizvoda')}</span>
  }

  return <span style={{ marginLeft: '0.5rem', fontSize: '1rem' }}><strong>{count}</strong> {t('pronađenih proizvoda')}</span>
}

const Filters = ({
  submit,
  filterValues,
  fetchFilteredFields,
  filteredFields,
  isSubmitting,
  isFieldsLoading,
  pagination,
  showFilterModal,
  setShowFilterModal,
  isMobileDevice
}) => {
  const [width, setWidth] = React.useState(filterValues?.width || '')
  const [height, setHeight] = React.useState(filterValues?.height || '')
  const [diameter, setDiameter] = React.useState(filterValues?.diameter || '')
  const [season, setSeason] = React.useState(filterValues?.season || '')
  const [tipVozila, setTipVozila] = React.useState(filterValues?.tire_vehicle_type || '')
  const [manufacturer, setManufacturer] = React.useState(filterValues?.manufacturer || '')
  const [activeTab, setActiveTab] = React.useState('filters')

  const router = useRouter()

  const { t, lang } = useTranslation('common')

  const locale = lang?.toUpperCase() || 'ME'

  const onCloseModal = () => {
    setShowFilterModal(false)
  }

  useEffect(() => {
    if (router.query['text-filter']) {
      setActiveTab('text')
    } else {
      setActiveTab('filters')
    }
  }, [router.query])

  useEffect(() => {
    if (showFilterModal === 'text') setActiveTab('text')
    if (showFilterModal === 'filters') setActiveTab('filters')
  }, [showFilterModal])

  useEffect(() => {
    if (filterValues?.width !== width || filterValues?.height !== height || filterValues?.diameter !== diameter ||
      filterValues?.season !== season || filterValues?.tire_vehicle_type !== tipVozila || filterValues?.manufacturer !== manufacturer
    ) {
      const payload = {
        locale
      }

      if (width && Number(width) !== -1) payload.width = width
      if (height && Number(height) !== -1) payload.height = height
      if (diameter && Number(diameter) !== -1) payload.diameter = diameter
      if (season && Number(season) !== -1) payload.season = season
      if (tipVozila && Number(tipVozila) !== -1) payload.tire_vehicle_type = tipVozila

      fetchFilteredFields({ group: 'gume', payload })
    }
  }, [width, height, diameter, season, tipVozila, manufacturer])

  useEffect(() => {
    if (filterValues?.width !== width) {
      setWidth(filterValues?.width || '')
    }

    if (filterValues?.height !== height) {
      setHeight(filterValues?.height || '')
    }

    if (filterValues?.diameter !== diameter) {
      setDiameter(filterValues?.diameter || '')
    }

    if (filterValues?.season !== season) {
      setSeason(filterValues?.season || '')
    }

    if (filterValues?.tire_vehicle_type !== tipVozila) {
      setTipVozila(filterValues?.tire_vehicle_type || '')
    }

    if (filterValues?.manufacturer !== manufacturer) {
      setManufacturer(filterValues?.manufacturer || '')
    }
  }, [filterValues?.width, filterValues?.height, filterValues?.diameter, filterValues?.season, filterValues?.tire_vehicle_type, filterValues?.manufacturer])

  return !isMobileDevice ? (
    <div className='polja-pretrage ads-filter ads-filter-vehicle-parts'>
      <FilterTabs activeTab={activeTab} onTabChange={setActiveTab} />

      <div className='vehicle-parts-filter'>
        {activeTab === 'text' ? (
          <div className='vehicle-parts-filter-section'>
            <TextSearch />
          </div>
        ) : (
          <>
            <div className='vehicle-parts-filter-section'>
              <div className='vehicle-parts-filter-items'>
                <Width
                  filteredFields={filteredFields}
                  width={width}
                  setWidth={setWidth}
                  isDisabled={isFieldsLoading || isSubmitting}
                />

                <Height
                  filteredFields={filteredFields}
                  height={height}
                  setHeight={setHeight}
                  isDisabled={isFieldsLoading || isSubmitting}
                />

                <Diameter
                  filteredFields={filteredFields}
                  diameter={diameter}
                  setDiameter={setDiameter}
                  isDisabled={isFieldsLoading || isSubmitting}
                />

                <VehicleType
                  filteredFields={filteredFields}
                  tipVozila={tipVozila}
                  setTipVozila={setTipVozila}
                  isDisabled={isFieldsLoading || isSubmitting}
                />

                <Season
                  filteredFields={filteredFields}
                  season={season}
                  setSeason={setSeason}
                  isDisabled={isFieldsLoading || isSubmitting}
                />

                <Brand
                  filteredFields={filteredFields}
                  manufacturer={manufacturer}
                  setManufacturer={setManufacturer}
                  isDisabled={isFieldsLoading || isSubmitting}
                />
              </div>

              <Buttons
                isFieldsLoading={isFieldsLoading}
                isSubmitting={isSubmitting}
                submit={submit}
                width={width}
                height={height}
                diameter={diameter}
                season={season}
                tipVozila={tipVozila}
                manufacturer={manufacturer}
                setWidth={setWidth}
                setHeight={setHeight}
                setDiameter={setDiameter}
                setSeason={setSeason}
                setTipVozila={setTipVozila}
                setManufacturer={setManufacturer}
                filteredFields={filteredFields}
              />

              {!isMobileDevice ? null : (
                <>
                  <div className='vehicle-parts-filter-section__count'>
                    <CountText count={pagination?.totalCount || 0} />
                  </div>
                  <hr className='vehicle-parts-filter-section__separator' />
                </>
              )}

              {filteredFields?.data?.fast_search?.tags?.length > 0 && (
                <>
                  <p
                    className='vehicle-parts-filter-section__title'
                    style={{ margin: '1rem 0 0.75rem 0', fontSize: 18 }}
                  >
                    {filteredFields?.data?.fast_search?.name}
                  </p>

                  <div className='vehicle-parts-quicksearch-items'>
                    {filteredFields?.data?.fast_search?.tags?.map((tag) => {
                      const url = getUrl({
                        width: tag.tire_width_slug,
                        height: tag.tire_height_slug,
                        diameter: tag.tire_diameter_slug
                      }, locale)

                      const isActive = filterValues?.width === tag.tire_width_slug && filterValues?.height === tag.tire_height_slug && filterValues?.diameter === tag.tire_diameter_slug

                      return (
                        <Link
                          key={tag.name}
                          as={url.asUrl}
                          href={url.href}
                          passHref
                        >
                          <a className={`vehicle-parts-quick-search-item ${isActive ? 'active' : ''}`}>{tag.name}</a>
                        </Link>
                      )
                    })}
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  ) : (
    <>
      {filteredFields?.data?.fast_search?.tags?.length > 0 && (
        <>
          <p className='vehicle-parts-filter-section__title' style={{ margin: '1rem 0 0.75rem 0' }}>{filteredFields?.data?.fast_search?.name}</p>

          <div className='vehicle-parts-quicksearch-items'>
            {filteredFields?.data?.fast_search?.tags?.map((tag) => {
              const url = getUrl({
                width: tag.tire_width_slug,
                height: tag.tire_height_slug,
                diameter: tag.tire_diameter_slug
              }, locale)

              const isActive = filterValues?.width === tag.tire_width_slug && filterValues?.height === tag.tire_height_slug && filterValues?.diameter === tag.tire_diameter_slug

              return (
                <Link
                  key={tag.name}
                  as={url.asUrl}
                  href={url.href}
                  passHref
                >
                  <a className={`vehicle-parts-quick-search-item ${isActive ? 'active' : ''}`}>{tag.name}</a>
                </Link>
              )
            })}
          </div>

          <VehiclePartsSummaryBar
            count={pagination?.totalCount || 0}
            onReset={() => {
              setShowFilterModal(false)
              router.push({ pathname: '/vehicleParts' }, `/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}`)
            }}
          />
        </>
      )}

      <Modal
        onClose={onCloseModal}
        open={showFilterModal}
        center
        closeOnOverlayClick
        showCloseIcon={false}
        styles={{
          modal: {
            width: '100%',
            margin: 0,
            verticalAlign: 'bottom',
            height: 'auto',
            padding: 0,
            backgroundClip: 'text',
            maxHeight: '80vh',
            minHeight: '60vh'
          }
        }}
      >
        <div className='polja-pretrage ads-filter ads-filter-vehicle-parts'>
          <div className='ads-filter-vehicle-parts-header'>
            <a href='javascript:void(0)' onClick={() => { setShowFilterModal(false) }}>
              <ReactSVG src='/icons/back.svg' wrapper='span' beforeInjection={svg => {
                svg.setAttribute('style', 'width: 30px; height: 30px; margin-right: 10px;')
                svg.querySelectorAll('path').forEach(path => {
                  path.setAttribute('fill', '#000')
                })
              }} />
            </a>

            <p className='ads-filter-vehicle-parts-header__title'>{activeTab === 'text' ? t('Pretraga po OE broju') : t('Pretraga po vozilu')}</p>

            <button
              className='ads-filter-vehicle-parts-header__reset'
              onClick={() => {
                setShowFilterModal(false)
                router.push({ pathname: '/vehicleParts' }, `/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}`)
              }}
            >
              <ReactSVG
                src='/icons/161.obrisati.svg'
                beforeInjection={svg => {
                  svg.setAttribute('style', 'width: 12px; height: auto; margin-right: 7px; margin-top: 3px;');
                }}
                className='pretraga-reset-filter'
              />

              <span>{t('resetSearchVehiclePartsText')}</span>
            </button>
          </div>

          <div className='vehicle-parts-filter'>
            {activeTab === 'text' ? (
              <div className='vehicle-parts-filter-section'>
                {!isMobileDevice ? <TextSearch /> : <TextSearchMobile setActiveTab={setActiveTab} />}
              </div>
            ) : (
              <>
                <div className='vehicle-parts-filter-section'>
                  <div className='vehicle-parts-filter-items'>
                    <Width
                      filteredFields={filteredFields}
                      width={width}
                      setWidth={setWidth}
                      isDisabled={isFieldsLoading || isSubmitting}
                    />

                    <Height
                      filteredFields={filteredFields}
                      height={height}
                      setHeight={setHeight}
                      isDisabled={isFieldsLoading || isSubmitting}
                    />

                    <Diameter
                      filteredFields={filteredFields}
                      diameter={diameter}
                      setDiameter={setDiameter}
                      isDisabled={isFieldsLoading || isSubmitting}
                    />

                    <VehicleType
                      filteredFields={filteredFields}
                      tipVozila={tipVozila}
                      setTipVozila={setTipVozila}
                      isDisabled={isFieldsLoading || isSubmitting}
                    />

                    <Season
                      filteredFields={filteredFields}
                      season={season}
                      setSeason={setSeason}
                      isDisabled={isFieldsLoading || isSubmitting}
                    />

                    <Brand
                      filteredFields={filteredFields}
                      manufacturer={manufacturer}
                      setManufacturer={setManufacturer}
                      isDisabled={isFieldsLoading || isSubmitting}
                    />

                    {activeTab === 'text' ? (
                      <button
                        className={`filter-buttons-search filter-buttons-search__toggle`}
                        onClick={() => {
                          setActiveTab('filters')
                        }}
                      >
                        <ReactSVG
                          src='/icons/pretraga-po-filterima.svg'
                          beforeInjection={svg => {
                            svg.setAttribute('style', 'width: 25px;')
                            svg.setAttribute('style', 'margin-right: 10px;')
                            svg.querySelectorAll('path').forEach(path => {
                              path.setAttribute('fill', '#bbb')
                            })
                          }}
                        />
                        <span style={{ textTransform: 'uppercase' }}>{t('Pretraga po filterima')}</span>
                      </button>
                    ) : (
                      <button
                        className={`filter-buttons-search filter-buttons-search__toggle`}
                        onClick={() => {
                          setActiveTab('text')
                        }}
                      >
                        <ReactSVG
                          src='/icons/pretraga-po-kataloskom-broju.svg'
                          beforeInjection={svg => {
                            svg.setAttribute('style', 'width: 25px;')
                            svg.setAttribute('style', 'margin-right: 10px;')
                            svg.querySelectorAll('path').forEach(path => {
                              path.setAttribute('fill', '#bbb')
                            })
                          }}
                        />
                        <span style={{ textTransform: 'uppercase' }}>{t('Pretraga po kataloškom broju')}</span>
                      </button>
                    )}
                  </div>
                </div>

                <ButtonMobile
                  isFieldsLoading={isFieldsLoading}
                  isSubmitting={isSubmitting}
                  submit={submit}
                  width={width}
                  height={height}
                  diameter={diameter}
                  season={season}
                  tipVozila={tipVozila}
                  manufacturer={manufacturer}
                  setWidth={setWidth}
                  setHeight={setHeight}
                  setDiameter={setDiameter}
                  setSeason={setSeason}
                  setTipVozila={setTipVozila}
                  setManufacturer={setManufacturer}
                  filteredFields={filteredFields}
                  onCloseModal={onCloseModal}
                />
              </>
            )}
          </div>
        </div>
      </Modal>
    </>
  )
}

const mapStateToProps = (state) => ({
  filteredFields: getFilteredFields(state),
  isFieldsLoading: getLoading(state),
  pagination: getPagination(state),
  isMobileDevice: getIsMobileDevice(state),
  showFilterModal: getShowFilterModal(state)
})

Filters.propTypes = {
  filterValues: PropTypes.shape({
    manufacturer: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    diameter: PropTypes.string,
    season: PropTypes.string,
    tire_vehicle_type: PropTypes.string
  }).isRequired,
  submit: PropTypes.func.isRequired,
  filteredFields: PropTypes.shape({
    data: PropTypes.shape({
      width: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      })),
      height: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      })),
      diameter: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      })),
      manufacturer: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired
      })),
      season: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired
      })),
      tire_vehicle_type: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        image_path: PropTypes.string.isRequired
      })),
      fast_search: PropTypes.shape({
        name: PropTypes.string.isRequired,
        tags: PropTypes.arrayOf(PropTypes.shape({
          name: PropTypes.string.isRequired,
          tire_diameter_slug: PropTypes.string.isRequired,
          tire_width_slug: PropTypes.string.isRequired,
          tire_height_slug: PropTypes.string.isRequired
        }))
      })
    })
  }).isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isFieldsLoading: PropTypes.bool.isRequired,
  fetchFilteredFields: PropTypes.func.isRequired
}

Filters.defaultProps = {
  isSubmitting: false,
  isFieldsLoading: false,
}

CountText.propTypes = {
  count: PropTypes.number.isRequired
}

export default connect(mapStateToProps, { fetchFilteredFields, setShowFilterModal })(Filters)
